module.exports = __webpack_public_path__ + "img/编辑.9355451f.svg";